import { Component, effect, signal } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import { Ballot } from 'src/app/ballot/backend-types';
import { BallotListService } from 'src/app/ballot-list/ballot-list.service';
import { Router } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import { petitionRoute} from '../../route-names';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { PetitionsItemComponent } from './petitions-item/petitions-item.component';
import { MatBadgeModule } from '@angular/material/badge';
import { ApiAboutService } from 'src/app/Services/api-about.service';
import { ElectorDataService } from 'src/app/Services/elector-data.service';

@Component({
    selector: 'app-petitions-panel',
    imports: [MatExpansionModule, MatIconModule, PetitionsItemComponent, MatBadgeModule],
    templateUrl: './petitions-panel.component.html',
    styleUrl: './petitions-panel.component.scss'
})
export class PetitionsPanelComponent {
  events: Ballot[] = [];
  eventsCount: number = 0;
  eventsOpenState = signal(false);
  
  constructor(
    private aboutService: ApiAboutService,
    private readonly listService: BallotListService,
    private readonly router: Router,
    private readonly userService: ElectorDataService,
    private announcer: LiveAnnouncer
  ) {
    effect(() => {
      this.events = listService.getBallots().filter((event) => event.eventType?.toLowerCase().includes("petition")) ?? [];
      this.eventsCount = this.events.length;
    })
  }

  selectedBallot(selectedEventId: number): void {
    let ballotIndex = this.events.findIndex((ballot) => (ballot.eventId === selectedEventId));
    if(ballotIndex < 0){
      console.error("Missing petition!");
      return;
    }
    this.aboutService.headerImageUrl.set(this.userService.getImageUrlForEventOrOrg(selectedEventId));
    this.aboutService.headerTitle.set(this.events[ballotIndex].voteEventData.description);
    this.aboutService.headerDates.set(this.listService.formatDateRange(this.events[ballotIndex]));
    this.aboutService.setElectionStartAndClose(this.events[ballotIndex].eventActivation, this.events[ballotIndex].eventExpiration);
    this.listService.setBallotService(this.listService.getOverallIndexForEventID(selectedEventId))
    this.router.navigate(petitionRoute);
  }

  onPanelOpen(): void {
    this.eventsOpenState.set(true);
    this.announcer.announce('You have ' + this.eventsCount + ' petitions available.', "assertive")
  }

  onPanelClose(): void {
    this.eventsOpenState.set(false);
    this.announcer.announce('Click to view your available petitions.' , "assertive")
  }

  get openDescriptionBallot(): string {
    return $localize`Select a petition to begin making selections.`;
  }

  get closeDescriptionBallot(): string {
    return $localize`Click here to view your available petitions.`;
  }

  get openDescriptionPetition(): string {
    return $localize`Select a petition to begin making selections.`;
  }

  get closeDescriptionPetition(): string {
    return $localize`Click here to view your available petitions.`;
  }
  get EventsOpenStateDescription(): string {
    return $localize`Click to view your available petitions.`;
  }

  numBallots(): number {
    return this.events.filter(b => this.listService.isActionable(b)).length;
  }

  areNoBallots(): boolean {
    return this.numBallots() == 0;
  }
}
